import waitlist from "@/assets/optimized-images/maqraah.jpg";
import WaitForm from "./WaitForm";

const Waiting = () => {
  return (
    <div className="font-[Mulish]">
      {/* Hero Banner */}
      <div className="bg-no-repeat bg-AdviceBg bg-cover relative mb-10">
        <div className="absolute inset-0 bg-[#000000CF]"></div>
        <div className="relative z-10">
          <div className="relative transform px-6 py-24 sm:py-32 flex flex-col items-center gap-6 text-white text-center">
            <h2 className="font-bold text-4xl sm:text-6xl">
              JOIN OUR WAIT-LIST
            </h2>
            <p className="text-lg sm:text-xl max-w-2xl">
              Secure your spot for our exclusive Quran memorization and Qira'at
              training program
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto space-y-12 p-4 sm:p-12">
        <div className="flex justify-center">
          <img
            src={waitlist}
            alt="Maqrah Quran Memorization Program"
            className="rounded-lg shadow-lg max-w-full sm:max-w-2xl"
          />
        </div>

        <div className="bg-slate-50 rounded-xl p-6 sm:p-12 shadow-md">
          <h3 className="text-3xl font-bold text-slate-800 mb-6">
            Why Join Our Waitlist?
          </h3>

          <div className="text-xl font-[Mulish] leading-8 text-slate-700">
            <p className="mb-6">
              Be the first to access our exclusive Quran memorization and
              Qira'at training! Join our waitlist today and unlock:
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-green-500">
                <h4 className="font-bold text-xl mb-2">Early Access</h4>
                <p>
                  Be among the first to enroll in our structured online courses
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-500">
                <h4 className="font-bold text-xl mb-2">
                  Personalized Learning
                </h4>
                <p>
                  Customized plans tailored specifically to your learning pace
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-purple-500">
                <h4 className="font-bold text-xl mb-2">Expert Guidance</h4>
                <p>Learn from qualified and experienced Quran teachers</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-yellow-500">
                <h4 className="font-bold text-xl mb-2">Global Community</h4>
                <p>
                  Join a supportive community of dedicated learners worldwide
                </p>
              </div>
            </div>

            <div className="text-center py-4">
              <p className="italic text-2xl font-semibold text-slate-800">
                Limited Spots Available! Secure Your Place Now!
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Form Section with Gradient Background */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 py-12">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold text-center mb-8 text-slate-800">
            Register for the Waitlist
          </h3>
          <WaitForm />
        </div>
      </div>
    </div>
  );
};

export default Waiting;
